// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eVenueForm {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 600px;
}

.eVenueForm__headerRow {
  display: flex;
  align-items: center;
  gap: 12px;
}

.eVenueForm__headerTitle {
  font-size: 18px;
  font-weight: 700;
  color: #465566;
  line-height: 1.2;
}

.eVenueForm__helpBtn {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid #7cc9dc;
  background: #eef9fc;
  color: #2fa8d3;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  padding: 0;
  cursor: pointer;
}

.eVenueForm__helpBtn:hover {
  background: #e3f5fb;
}

.eVenueForm__grid {
  display: grid;
  grid-template-columns: minmax(320px, 380px) minmax(760px, 1fr);
  gap: 32px;
  align-items: start;
}

.eVenueForm__main,
.eVenueForm__mapCol,
.eVenueForm__field {
  min-width: 0;
  width: 100%;
}

.eVenueForm__main {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.eVenueForm__field {
  margin-bottom: 0;
}

.eVenueForm__field--name,
.eVenueForm__field--postcode {
  max-width: 300px;
}

.eVenueForm__field--home {
  padding-top: 4px;
}

.eVenueForm__label {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #465566;
  margin-bottom: 8px;
}

.eVenueForm__switchRow {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.eVenueForm__switchRow .form-check-label,
.eVenueForm__switchRow .custom-control-label {
  margin-bottom: 0;
}

.eVenueForm__mapCard {
  border: 1px solid #e5eaf0;
  border-radius: 14px;
  background: linear-gradient(180deg, #fbfdff 0%, #f8fafc 100%);
  padding: 16px;
}

.eVenueForm__mapTitle {
  font-size: 15px;
  font-weight: 700;
  color: #465566;
  margin-bottom: 4px;
}

.eVenueForm__mapText {
  font-size: 12px;
  line-height: 1.4;
  color: #7b8794;
  margin-bottom: 10px;
}

.eVenue_map {
  display: block !important;
  width: 100% !important;
  max-width: none !important;
  height: 400px;
  margin: 0;
  border-radius: 12px;
  overflow: hidden;
}

.eVenueForm__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 4px;
}

.eVenueForm__btnSecondary,
.eVenueForm__btnPrimary {
  min-width: 130px;
  min-height: 42px;
  border-radius: 10px;
}

@media (max-width: 991px) {
  .eVenueForm {
    min-height: 0;
  }

  .eVenueForm__grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .eVenueForm__field--name,
  .eVenueForm__field--postcode {
    max-width: 100%;
  }

  .eVenue_map {
    height: 280px;
  }
}

/* Compact create/edit venue form */
.eVenueForm {
  min-height: 0;
  gap: 18px;
}

.eVenueForm__main {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 16px;
}

.eVenueForm__field--home,
.eVenueForm__mapPreview {
  grid-column: 1 / -1;
}

.eVenueForm__switchRow {
  min-height: 40px;
  padding: 0;
  border: 0;
  background: transparent;
}

.eVenueForm__mapPreview {
  position: relative;
  min-height: 240px;
  overflow: hidden;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 10px;
  background: #e9eef2;
}

.eVenueForm__workingMap {
  display: block !important;
  width: 100% !important;
  max-width: none !important;
  height: 240px !important;
  margin: 0 !important;
  border-radius: 10px;
  overflow: hidden;
}

.eVenueForm__mapPlaceholder {
  position: relative;
  height: 120px;
  overflow: hidden;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 10px;
  background-color: #e9eef2;
  background-image: linear-gradient(rgba(15, 23, 42, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(15, 23, 42, 0.05) 1px, transparent 1px);
  background-size: 26px 26px;
}

.eVenueForm__mapRoad {
  position: absolute;
  display: block;
  background: rgba(255, 255, 255, 0.72);
}

.eVenueForm__mapRoad--horizontal {
  top: 32%;
  right: 0;
  left: 0;
  height: 12px;
  transform: rotate(-4deg);
}

.eVenueForm__mapRoad--vertical {
  top: 0;
  bottom: 0;
  left: 58%;
  width: 10px;
  transform: rotate(6deg);
}

.eVenueForm__mapPin {
  position: absolute;
  top: 52%;
  left: 50%;
  color: #c23648;
  filter: drop-shadow(0 4px 6px rgba(15, 23, 42, 0.3));
  transform: translate(-50%, -100%);
}

.eVenueForm__mapPin svg {
  width: 34px;
  height: 34px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}

.eVenueForm__postcodeChip {
  position: absolute;
  bottom: 9px;
  left: 9px;
  display: inline-flex;
  height: 26px;
  align-items: center;
  padding: 0 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.14);
  color: var(--text-strong, #142033);
  font-size: 12px;
  font-weight: 600;
}

.eVenueForm__mapCaption {
  position: absolute;
  top: 8px;
  right: 9px;
  color: var(--text-subtle, #8290a3);
  font-family: var(--font-mono, monospace);
  font-size: 10.5px;
  letter-spacing: 0.02em;
}

@media (max-width: 640px) {
  .eVenueForm__main {
    grid-template-columns: 1fr;
  }

  .eVenueForm__field--home,
  .eVenueForm__mapPreview {
    grid-column: auto;
  }
}

/* Design system venue create / edit form */
.eVenueForm {
  min-height: 540px;
  gap: 20px;
}

.eVenueForm__headerRow {
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.eVenueForm__headerIcon {
  display: inline-flex;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: var(--blue-600, #227ebd);
  color: #fff;
}

.eVenueForm__headerIcon svg,
.eVenueForm__btnPrimary svg {
  width: 19px;
  height: 19px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.9;
}

.eVenueForm__headerCopy {
  min-width: 0;
}

.eVenueForm__headerTitle {
  color: var(--text-strong, #142033);
  font-size: 17px;
  font-weight: 760;
}

.eVenueForm__headerSubtitle {
  margin-top: 2px;
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
}

.eVenueForm__helpBtn {
  margin-left: auto;
  border-radius: 9px;
}

.eVenueForm__grid {
  grid-template-columns: minmax(0, 1fr);
  gap: 18px;
}

.eVenueForm__main {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.eVenueForm__field--name,
.eVenueForm__field--postcode {
  max-width: none;
}

.eVenueForm__field--home {
  grid-column: 1 / -1;
}

.eVenueForm__label {
  color: var(--text-strong, #142033);
  font-size: 12.5px;
}

.eVenueForm .form-control,
.eVenueForm .mFullWidth input {
  min-height: 42px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 9px;
  color: var(--text-strong, #142033);
  font-size: 13.5px;
}

.eVenueForm__hint {
  margin-top: 7px;
  color: var(--text-muted, #69778a);
  font-size: 11.5px;
  line-height: 1.4;
}

.eVenueForm__switchRow {
  padding: 10px 12px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 10px;
  background: var(--slate-25, #f8fafc);
}

.eVenueForm__mapCard {
  width: 100%;
  border-color: var(--border-subtle, #dbe3ec);
  background: var(--slate-25, #f8fafc);
}

.eVenue_map {
  height: 300px;
}

.eVenueForm__footer {
  padding-top: 16px;
  border-top: 1px solid var(--border-subtle, #dbe3ec);
}

.eVenueForm__btnSecondary,
.eVenueForm__btnPrimary {
  display: inline-flex;
  min-width: 130px;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  border-radius: 10px;
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
}

.eVenueForm__btnSecondary {
  border: 1px solid var(--border-default, #cbd5e1);
  background: #fff;
  color: var(--text-body, #334155);
}

.eVenueForm__btnPrimary {
  border: 1px solid var(--blue-600, #227ebd);
  background: var(--blue-600, #227ebd);
  color: #fff;
}

@media (max-width: 991px) {
  .eVenueForm__grid {
    grid-template-columns: 1fr;
  }

  .eVenueForm__main {
    grid-template-columns: 1fr;
  }

  .eVenueForm__field--home {
    grid-column: auto;
  }
}

/* Keep the modal compact; these overrides intentionally follow the legacy form rules above. */
.eVenueForm {
  min-height: 0;
  gap: 18px;
}

.eVenueForm__main {
  gap: 14px 16px;
}

.eVenueForm__switchRow {
  min-height: 40px;
  padding: 0;
  border: 0;
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/School/Venues/VenueForm/VenuesForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,yBAAyB;EACzB;uEACqE;EACrE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,MAAM;EACN,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,oDAAoD;EACpD,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,qCAAqC;EACrC,4CAA4C;EAC5C,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kCAAkC;EAClC,wCAAwC;EACxC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA,2CAA2C;AAC3C;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,8FAA8F;AAC9F;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;AACzB","sourcesContent":[".eVenueForm {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-height: 600px;\n}\n\n.eVenueForm__headerRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.eVenueForm__headerTitle {\n  font-size: 18px;\n  font-weight: 700;\n  color: #465566;\n  line-height: 1.2;\n}\n\n.eVenueForm__helpBtn {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 1px solid #7cc9dc;\n  background: #eef9fc;\n  color: #2fa8d3;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1;\n  padding: 0;\n  cursor: pointer;\n}\n\n.eVenueForm__helpBtn:hover {\n  background: #e3f5fb;\n}\n\n.eVenueForm__grid {\n  display: grid;\n  grid-template-columns: minmax(320px, 380px) minmax(760px, 1fr);\n  gap: 32px;\n  align-items: start;\n}\n\n.eVenueForm__main,\n.eVenueForm__mapCol,\n.eVenueForm__field {\n  min-width: 0;\n  width: 100%;\n}\n\n.eVenueForm__main {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.eVenueForm__field {\n  margin-bottom: 0;\n}\n\n.eVenueForm__field--name,\n.eVenueForm__field--postcode {\n  max-width: 300px;\n}\n\n.eVenueForm__field--home {\n  padding-top: 4px;\n}\n\n.eVenueForm__label {\n  display: block;\n  font-size: 14px;\n  font-weight: 700;\n  color: #465566;\n  margin-bottom: 8px;\n}\n\n.eVenueForm__switchRow {\n  min-height: 40px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.eVenueForm__switchRow .form-check-label,\n.eVenueForm__switchRow .custom-control-label {\n  margin-bottom: 0;\n}\n\n.eVenueForm__mapCard {\n  border: 1px solid #e5eaf0;\n  border-radius: 14px;\n  background: linear-gradient(180deg, #fbfdff 0%, #f8fafc 100%);\n  padding: 16px;\n}\n\n.eVenueForm__mapTitle {\n  font-size: 15px;\n  font-weight: 700;\n  color: #465566;\n  margin-bottom: 4px;\n}\n\n.eVenueForm__mapText {\n  font-size: 12px;\n  line-height: 1.4;\n  color: #7b8794;\n  margin-bottom: 10px;\n}\n\n.eVenue_map {\n  display: block !important;\n  width: 100% !important;\n  max-width: none !important;\n  height: 400px;\n  margin: 0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.eVenueForm__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding-top: 4px;\n}\n\n.eVenueForm__btnSecondary,\n.eVenueForm__btnPrimary {\n  min-width: 130px;\n  min-height: 42px;\n  border-radius: 10px;\n}\n\n@media (max-width: 991px) {\n  .eVenueForm {\n    min-height: 0;\n  }\n\n  .eVenueForm__grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .eVenueForm__field--name,\n  .eVenueForm__field--postcode {\n    max-width: 100%;\n  }\n\n  .eVenue_map {\n    height: 280px;\n  }\n}\n\n/* Compact create/edit venue form */\n.eVenueForm {\n  min-height: 0;\n  gap: 18px;\n}\n\n.eVenueForm__main {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px 16px;\n}\n\n.eVenueForm__field--home,\n.eVenueForm__mapPreview {\n  grid-column: 1 / -1;\n}\n\n.eVenueForm__switchRow {\n  min-height: 40px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n}\n\n.eVenueForm__mapPreview {\n  position: relative;\n  min-height: 240px;\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 10px;\n  background: #e9eef2;\n}\n\n.eVenueForm__workingMap {\n  display: block !important;\n  width: 100% !important;\n  max-width: none !important;\n  height: 240px !important;\n  margin: 0 !important;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.eVenueForm__mapPlaceholder {\n  position: relative;\n  height: 120px;\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 10px;\n  background-color: #e9eef2;\n  background-image: linear-gradient(rgba(15, 23, 42, 0.05) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(15, 23, 42, 0.05) 1px, transparent 1px);\n  background-size: 26px 26px;\n}\n\n.eVenueForm__mapRoad {\n  position: absolute;\n  display: block;\n  background: rgba(255, 255, 255, 0.72);\n}\n\n.eVenueForm__mapRoad--horizontal {\n  top: 32%;\n  right: 0;\n  left: 0;\n  height: 12px;\n  transform: rotate(-4deg);\n}\n\n.eVenueForm__mapRoad--vertical {\n  top: 0;\n  bottom: 0;\n  left: 58%;\n  width: 10px;\n  transform: rotate(6deg);\n}\n\n.eVenueForm__mapPin {\n  position: absolute;\n  top: 52%;\n  left: 50%;\n  color: #c23648;\n  filter: drop-shadow(0 4px 6px rgba(15, 23, 42, 0.3));\n  transform: translate(-50%, -100%);\n}\n\n.eVenueForm__mapPin svg {\n  width: 34px;\n  height: 34px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2;\n}\n\n.eVenueForm__postcodeChip {\n  position: absolute;\n  bottom: 9px;\n  left: 9px;\n  display: inline-flex;\n  height: 26px;\n  align-items: center;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.95);\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.14);\n  color: var(--text-strong, #142033);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.eVenueForm__mapCaption {\n  position: absolute;\n  top: 8px;\n  right: 9px;\n  color: var(--text-subtle, #8290a3);\n  font-family: var(--font-mono, monospace);\n  font-size: 10.5px;\n  letter-spacing: 0.02em;\n}\n\n@media (max-width: 640px) {\n  .eVenueForm__main {\n    grid-template-columns: 1fr;\n  }\n\n  .eVenueForm__field--home,\n  .eVenueForm__mapPreview {\n    grid-column: auto;\n  }\n}\n\n/* Design system venue create / edit form */\n.eVenueForm {\n  min-height: 540px;\n  gap: 20px;\n}\n\n.eVenueForm__headerRow {\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.eVenueForm__headerIcon {\n  display: inline-flex;\n  width: 42px;\n  height: 42px;\n  flex: 0 0 42px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: var(--blue-600, #227ebd);\n  color: #fff;\n}\n\n.eVenueForm__headerIcon svg,\n.eVenueForm__btnPrimary svg {\n  width: 19px;\n  height: 19px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.9;\n}\n\n.eVenueForm__headerCopy {\n  min-width: 0;\n}\n\n.eVenueForm__headerTitle {\n  color: var(--text-strong, #142033);\n  font-size: 17px;\n  font-weight: 760;\n}\n\n.eVenueForm__headerSubtitle {\n  margin-top: 2px;\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n}\n\n.eVenueForm__helpBtn {\n  margin-left: auto;\n  border-radius: 9px;\n}\n\n.eVenueForm__grid {\n  grid-template-columns: minmax(0, 1fr);\n  gap: 18px;\n}\n\n.eVenueForm__main {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px;\n}\n\n.eVenueForm__field--name,\n.eVenueForm__field--postcode {\n  max-width: none;\n}\n\n.eVenueForm__field--home {\n  grid-column: 1 / -1;\n}\n\n.eVenueForm__label {\n  color: var(--text-strong, #142033);\n  font-size: 12.5px;\n}\n\n.eVenueForm .form-control,\n.eVenueForm .mFullWidth input {\n  min-height: 42px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 9px;\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n}\n\n.eVenueForm__hint {\n  margin-top: 7px;\n  color: var(--text-muted, #69778a);\n  font-size: 11.5px;\n  line-height: 1.4;\n}\n\n.eVenueForm__switchRow {\n  padding: 10px 12px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 10px;\n  background: var(--slate-25, #f8fafc);\n}\n\n.eVenueForm__mapCard {\n  width: 100%;\n  border-color: var(--border-subtle, #dbe3ec);\n  background: var(--slate-25, #f8fafc);\n}\n\n.eVenue_map {\n  height: 300px;\n}\n\n.eVenueForm__footer {\n  padding-top: 16px;\n  border-top: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.eVenueForm__btnSecondary,\n.eVenueForm__btnPrimary {\n  display: inline-flex;\n  min-width: 130px;\n  min-height: 42px;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 16px;\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 13.5px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.eVenueForm__btnSecondary {\n  border: 1px solid var(--border-default, #cbd5e1);\n  background: #fff;\n  color: var(--text-body, #334155);\n}\n\n.eVenueForm__btnPrimary {\n  border: 1px solid var(--blue-600, #227ebd);\n  background: var(--blue-600, #227ebd);\n  color: #fff;\n}\n\n@media (max-width: 991px) {\n  .eVenueForm__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .eVenueForm__main {\n    grid-template-columns: 1fr;\n  }\n\n  .eVenueForm__field--home {\n    grid-column: auto;\n  }\n}\n\n/* Keep the modal compact; these overrides intentionally follow the legacy form rules above. */\n.eVenueForm {\n  min-height: 0;\n  gap: 18px;\n}\n\n.eVenueForm__main {\n  gap: 14px 16px;\n}\n\n.eVenueForm__switchRow {\n  min-height: 40px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
